import type { PropsWithChildren } from 'react';
import type { JSX } from '@gov-design-system-ce/components';
import type { GovDialogProps } from '@gov-design-system-ce/react/gov-dialog';
import { GovDialog } from '@gov-design-system-ce/react/gov-dialog';
import { useGlobalLocale } from '@gov-nx/core/service/translations/useGlobalLocale';

interface Props extends Omit<GovDialogProps, 'open'> {
	isOpen: JSX.GovDialog['open'];
}

export const Dialog = ({
	children,
	isOpen,
	onClose,
	...props
}: PropsWithChildren<Props>) => {
	const { t } = useGlobalLocale();
	return (
		<GovDialog
			{...props}
			open={isOpen}
			onClose={onClose}
			accessibleCloseLabel={t('akce.wcag.zavrit-dialog')}
			className="mt-0!">
			{children}
		</GovDialog>
	);
};
